<template>
	<div>
		<div class="title-container">
			<div class="title">
				{{ customer.name }}
				<div class="subtitle">Customer Details</div>
			</div>
			<div class="buttons">
				<router-link to="/commerce/customers" exact class="button"><div class="hover-title">Go Back</div><span class="fa fa-chevron-left"></span></router-link>
			</div>
		</div>
		<div class="input-container">
			<div class="input-title">Customer Name</div>
			<div class="input-static-text">{{ customer.name }}</div>
		</div>
		<div class="input-container">
			<div class="input-title">Email Address</div>
			<div class="input-static-text">{{ customer.email }}</div>
		</div>
		<div class="input-container">
			<div class="input-checkbox">
				<span class="checkmark-container">
					<label class="checkbox">
						<input type="checkbox" id="is_wholesale" name="is_wholesale" v-model="customer.is_wholesale" :value="true">
						<span class="checkmark"></span>
					</label>
				</span>
				<label for="is_wholesale" class="input-checkbox-text">Grant this customer access to wholesale pricing</label>
			</div>
		</div>
		<div class="input-container">
			<div class="input-title">Last Order</div>
			<div class="input-static-text">{{ latestOrderAt }}</div>
		</div>
		<div class="title-container">
			<div class="title"><span>{{ customer.orders.length }}</span> Order{{ customer.orders.length !== 1 ? 's' : '' }} Placed</div>
		</div>
		<div class="list-page">
			<div class="list-container">
				<div class="table">
					<nothing-here v-if="customer.orders.length === 0" text="No Orders Yet"></nothing-here>

					<div v-if="customer.orders.length > 0" class="row heading">
						<div class="cell"><span>Ordered On<span class="fa fa-angle-down"></span></span></div>
						<div class="cell"><span>Shipped To</span></div>
						<div class="cell"><span>Order Total</span></div>
						<div class="cell"><span>Status</span></div>
						<div class="cell"></div>
					</div>
					<div v-for="order in customer.orders" :key="`order-${ order.id }`" class="row">
						<div class="cell">{{ date(order.created_at) }}</div>
						<div class="cell">{{ order.shipping_city }}, {{ order.shipping_state }}</div>
						<div class="cell">{{ order.order_total / 100 | currency }}</div>
						<div class="cell"><span class="tag-wrapper neutral-bg">{{ order.status.toLowerCase() | capitalize  }}</span></div>
						<div class="cell align-right">
							<div class="buttons"><router-link :to="`/commerce/orders/${ order.id }/details`" class="button"><div class="hover-title">View Details</div><span class="fa fa-search"></span></router-link></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="buffer large"></div>
		<div v-if="customer.addresses.length > 0">
			<div class="title-container">
				<div class="title"><span>{{ customer.addresses.length }}</span> Address{{ customer.addresses.length !== 1 ? 'es' : '' }} On File</div>
			</div>
			<!-- BELOW SHOWS TWO DIFFERENT POSSIBLE STATES OF AN ADDRESS
			DEFINES WHETHER OR NOT A PHONE NUMBER OR DELIVERY NOTES EXIST -->
			<div class="liquid-form remove-padding-bottom remove-padding-top">
				<div v-for="address in customer.addresses" :key="`address-${ address.id }`" class="conjoin-input-containers">
					<div class="input-container">
						<div class="input-title">Recipient(s)</div>
						<div class="input-static-text">{{ address.recipient_name }}</div>
					</div>
					<div class="input-container">
						<div class="input-title">Address Line 1</div>
						<div class="input-static-text">{{ address.address1 }}</div>
					</div>
					<div v-if="address.address2" class="input-container">
						<div class="input-title">Address Line 2</div>
						<div class="input-static-text">{{ address.address2 }}</div>
					</div>
					<div class="input-container">
						<div class="input-title">City, State, Zip</div>
						<div class="input-static-text">{{ address.city }}, {{ address.state }} {{ address.zip }}</div>
					</div>
					<div v-if="address.instructions" class="input-container">
						<div class="input-title">Delivery Notes</div>
						<div class="input-static-text">{{ address.instructions }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import moment from 'moment';

export default {

	name: 'CustomerDetailsPage',

	async asyncData({ app, route }) {
		const { data } = await app.$api.get(`/commerce/customers/${ route.params.id }`);

		const { customer, categories, ...moduleData } = data;

		return {
			customer,
			moduleData,
		};
	},

	data() {
		return {
			saving: false,
			customer: {},
		};
	},

	computed: {

		customerCreatedAt() {
			return moment.tz(this.customer.created_at, 'UTC').format('MMMM D, YYYY @ hh:mmA');
		},

		latestOrderAt() {
			if (this.customer.orders.length > 0) {
				return moment(this.customer.orders[0].created_at).format('MMMM D, YYYY');
			}

			return 'Never';
		},

	},

	watch: {

		'customer.is_wholesale': function(newValue) {
			this.$api.put(`/commerce/customers/${ this.customer.id }`, { is_wholesale: newValue });
			this.$store.dispatch('addToast', `Customer will now use ${ newValue ? 'wholesale' : 'retail' } pricing`);
		},

	},

	methods: {

		date(date) {
			return moment(date).format('MMMM DD, YYYY');
		},

	}

};

</script>
